/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/


import { axiosInstance } from '../axiosInstance'
export const getHashicorpAllUsers = param => {
    try {

        return axiosInstance.post(`/api/gcadmin/v1/vault/listAllUsers?authMethod=` + param.authMethod).then(res => res.data);
    } catch (error) {
        throw error;
    }
}
export const createHashicorpUser = param => {
    try {
        console.log(`/api/gcadmin/v1/vault/createUserPass?userName=` + param.userName + '&userPass=' + param.userPass + '&policyName=' + param.policyName);
        return axiosInstance.post(`/api/gcadmin/v1/vault/createUserPass?userName=` + param.userName + '&userPass=' + param.userPass + '&policyName=' + param.policyName).then(res => res.data);

    } catch (error) {
        throw error;
    }
}
export const getSecret = param => {
    try {
        return axiosInstance.post(`/api/gcadmin/v1/vault/getSecret?getchkdid=` + param.getchkdid + `&appName=` + param.appName, param).then(res => res.data);

    } catch (error) {
        throw error;
    }
}
export const writeSecret = param => {
    try {
        return axiosInstance.post(`/api/gcadmin/v1/vault/writeSecret?getchkdid=` + param.getchkdid + `&appName=` + param.appName+ `&userName=` + param.userName+ `&userPass=` + param.userPass, param).then(res => res.data);

    } catch (error) {
        throw error;
    }
}
